import React from 'react';
import { Grid, Typography, Divider, Box } from '@mui/material';
import '../../../styles/report.css';
import { motion } from "framer-motion/dist/framer-motion";

/**
 * This component renders a titled list of key-value pairs.
 */

const PrintStyles = () => (
    <style>
        {`
        @media print {
            .subsection-print-wrapper {
                break-inside: avoid; /* Prevents this whole block from splitting in a multi-column layout */
                padding-top: 8px;
            }

            .subsection-print-title {
                text-align: center;
                font-family: 'Times New Roman', Times, serif;
                font-size: 11pt;
                font-weight: bold;
                color: #000;
            }

            .subsection-print-divider {
                margin: 4px 0 8px 0;
                border-color: #ccc !important;
            }
            
            .subsection-print-item {
                display: grid;
                grid-template-columns: 7fr 5fr; /* Replicates xs={7} and xs={5} */
                border-bottom: 1px solid #eee;
                padding: 2px 0;
            }
            
            .subsection-print-label, .subsection-print-value {
                font-family: 'Times New Roman', Times, serif;
                font-size: 10pt;
                color: #000;
            }
        }
        `}
    </style>
);


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 25 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
};

const SubSection = (props) => {
    // Accepting PrintView prop
    const { component, PrintView } = props;

    const OrderedSubSections = [...component.SubSections].sort((a, b) => parseInt(a.Order) - parseInt(b.Order));
    const FilteredSubsections = OrderedSubSections.filter((a) => a.Visible === '1');

    if (PrintView === true) {
        return (
            <div className="subsection-print-wrapper">
                <PrintStyles />
                <div className="subsection-print-title">{component.Label}</div>
                <Divider orientation='horizontal' className="subsection-print-divider" />
                {FilteredSubsections && FilteredSubsections.map((displayValues, index) => (
                    <div className="subsection-print-item" key={"print_sub_" + index}>
                        <div className="subsection-print-label">{displayValues.Label}</div>
                        <div className="subsection-print-value">{displayValues.Value}</div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <Grid container direction="row" mt={1}>
            <Grid item xs={12}>
                <Box>
                    <Typography variant="body1" fontWeight="bold" align="center">{component.Label}</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} m={1}>
                <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
            </Grid>
            <Grid item xs={12} >
                {FilteredSubsections && FilteredSubsections.map((displayValues, index) => (
                    <motion.div variants={motionVariants} initial="hidden" animate="show" key={"demographics" + index} >
                        <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                            <Grid container direction="row" alignItems="center" spacing={2}>
                                <Grid item xs={7}>
                                    <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </motion.div>
                ))}
            </Grid>
        </Grid>
    );
};

export default SubSection;